import React, { Fragment, PureComponent } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
// import axios from "axios";

// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)

import MyMemberShipNew from "./MyMemberShipNew";
import MyCashNew from "./MyCashNew";
import { isMobile, isAndroid, isIOS } from "react-device-detect";

class MyPay extends PureComponent {
  state = {
    index: this.props.childProps.index ? this.props.childProps.index : 0,
  };

  componentDidMount = () => {};
  _changeIndex = (index) => {
    const { _myMenu } = this.props.childProps;
    _myMenu(index);
  };
  render() {
    const { index } = this.props.childProps;
    return (
      <Fragment>
        <div className="my_con">
          <div className="my_tab">
            {isMobile ? null : (
              <h3>
                <a href="#" class="btn_back"></a>나의 결제내역
              </h3>
            )}
            <ul>
              <li>
                <button
                  type="button"
                  className={index === 2 ? "active" : null}
                  onClick={() => this._changeIndex(2)}
                >
                  멤버십 결제내역
                </button>
              </li>
              <li>
                <button
                  type="button"
                  className={index === 3 ? "active" : null}
                  onClick={() => this._changeIndex(3)}
                >
                  포인트 사용 내역
                </button>
              </li>
            </ul>
          </div>

          {index === 2 ? (
            <MyMemberShipNew />
          ) : index === 3 ? (
            <MyCashNew />
          ) : null}
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(React.memo(MyPay)));
